<template>
  <div class="c-app flex-row align-items-center login">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol class="col-12">
          <CAlert color="danger" closeButton :show.sync="loginError">
            {{ loginError }}
          </CAlert>

          <div class="col-12 p-0 m-auto tablet-bg-12 tablet-sm-8">
            <CCard
              class="
                col-4
                tablet-bg-8
                mx-auto
                card--custom
                animate__animated animate__fadeIn
              "
            >
              <CCardBody>
                <div class="card-header mb-4 pb-0">
                  <h5 class="text-center mb-4">Ingresa a tu cuenta</h5>
                </div>
                <CForm @submit.prevent="checkForm">
                  <div class="form-group relative group--custom">
                    <CInput
                      placeholder="usuario"
                      autocomplete="usaurio"
                      v-model="usuario.userName"
                    >
                      <template #prepend-content
                        ><CIcon name="cil-user"
                      /></template>
                    </CInput>
                  </div>
                  <div class="form-group relative group--custom">
                    <CInput
                      placeholder="Password"
                      type="password"
                      autocomplete="curent-password"
                      v-model="usuario.password"
                    >
                      <template #prepend-content
                        ><CIcon name="cil-lock-locked"
                      /></template>
                    </CInput>
                  </div>

                  <div class="login__errors">
                    <div
                      class="
                        alert alert-danger
                        animate__animated animate__slideInUp animate__faster
                      "
                      v-for="(error, i) in errors"
                      :key="i"
                    >
                      {{ error }}
                    </div>
                  </div>

                  <div class="form-group mt-4 d-flex justify-content-center">
                    <button
                      class="btn btn-primary--custom flex-grow-1"
                      @click="coverLoading"
                    >
                      Iniciar sesión
                    </button>
                  </div>
                  <div class="text-center mb-3 fs-14">
                    <div>
                      <p class="mt-4 mb-0">¿Olvidaste tu contraseña?</p>
                      <a
                        @click="showModal = true"
                        class="text-primary--custom text-underline pointer"
                        >Recupera el acceso a tu cuenta</a
                      >
                    </div>
                  </div>
                  <div class="text-center card-footer fs-14">
                    <div>
                      <p class="mt-1 mb-0">¿No tienes cuenta?</p>
                      <router-link
                        to="register"
                        class="text-primary--custom text-underline"
                        >Regístrate</router-link
                      >
                    </div>
                  </div>
                </CForm>
              </CCardBody>
              <small class="text-primary col-12 text-center mb-3">
                ¿Eres desarrollador infonavit? 
                <router-link to="/pages/infonavit/register" class="text-primary--custom">click aquí</router-link>
              </small>
            </CCard>
          </div>
        </CCol>
      </CRow>
    </CContainer>

    <!-- Modal recuperar contraseña -->
    <CModal :show.sync="showModal" :centered="true" title="Modal title 2">
        <label for="">Escribe tu correo electrónico</label>
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon1"><i class="fas fa-envelope"></i></span>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Username"
          aria-label="Username"
          aria-describedby="basic-addon1"
        />
      </div>
      <template #header>
        <h6 class="modal-title">Recupera tu contraseña</h6>
        <CButtonClose @click="showModal = false" class="text-dark" />
      </template>
      <template #footer>
        <CButton @click="showModal = false" color="outline-secondary"
          >Cancelar</CButton
        >
        <CButton color="primary">Enviar</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      errors: [],
      usuario: {
        userName: "",
        password: "",
      },
      showModal: false,
      expression: /^[A-Za-z0-9]+$/,
    };
  },
  methods: {
    checkForm: function (e) {
      // console.log(this.$store.state);
      // this.coverLoading();
      // return;
      this.errors = [];
      if (!this.usuario.userName) this.errors.push("Usuario requerido");
      if (!this.usuario.password) {
        this.errors.push("Password requerido");
        this.coverLoading(false);
      } else if (
        !this.expression.test(this.usuario.password) ||
        this.usuario.password.length < 3
      ) {
        this.errors.push("Password Invalido");
        this.coverLoading(false);
      }
      if (!this.errors.length) {
        this.$store.dispatch("login", {usuario: this.usuario});
      } else {
        e.preventDefault();
        return true;
      }
    },
    coverLoading(show = true) {
      this.$store.state.Loading = true;
      if (!show) {
        this.$store.state.Loading = false;
      }
    },
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "loginSuccessful"]),
  },
};
</script>
